__turbopack_context__.v({
  "markdown": "f3oeWa_markdown",
});
